import React from 'react';
import { Box } from 'grommet';
import { Layout } from '@/components/layout/Layout';
import { GrowYourBusiness } from '@/components/home/GrowYourBusiness';
import { TrustedBy } from '@/components/home/TrustedBy';
import { Pricing } from '@/components/home/Pricing';
import { About } from '@/components/home/About';
import { CTA } from '@/components/CTA';
import { SEO } from '@/components/SEO';
import { ClientTestimony } from '@/components/home/ClientTestimony';
import { IntelligentScanResults } from '@/components/home/IntelligentScanResults';
import { WhyUs } from '@/components/home/WhyUs';

const Home = () => (
  <Layout>
    <SEO title="Penetration Testing & Cybersecurity Software" />

    <Box margin={{ top: `medium`, bottom: `xlarge` }} gap="xlarge">
      <GrowYourBusiness />
      <TrustedBy />
      <About />
      <Pricing />
      <IntelligentScanResults />
      <ClientTestimony />
      <WhyUs />
      <CTA />
    </Box>
  </Layout>
);

export default Home;
